// assets/js/components/revenue-calculator/steps/step-6b.js
var ui = require("../ui");
var data = require("../data");
var validate = require("../validate");

var PROMOTE_OPTS = ["Gift cards", "Packages", "Memberships", "Loyalty offers"];

// The stored value is the star count ("0" = no rating): the lead API validates
// googleRating as a number 0-5, so a translated label like "4 stars" was rejected
// and every advanced-path lead was lost.
var RATING_OPTS = [
    { value: "0", label: _t("No rating") }, { value: "1", label: _t("1 star") }, { value: "2", label: _t("2 stars") },
    { value: "3", label: _t("3 stars") }, { value: "4", label: _t("4 stars") }, { value: "5", label: _t("5 stars") }
];

function render(state) {
    var d = state.d;
    var promotes = d.promotes || [];
    var html = ui.stepLabel(_t("Advanced step 2 of 3")) + ui.h2(_t("How do you currently drive bookings?")) +
        ui.sub(_t("This helps us estimate your marketing and visibility gap."));

    html += ui.field({
        id: "rc-google-rating", label: _t("Google review rating"), required: true,
        inner: ui.radioGroup({ id: "rc-google-rating", value: d.googleRating, options: RATING_OPTS })
    });
    if (d.googleRating && d.googleRating !== "0") {
        html += ui.field({
            id: "rc-google-reviews", label: _t("Number of Google reviews"), required: true,
            inner: ui.textInput({ id: "rc-google-reviews", type: "number", value: d.googleReviews, placeholder: _t("e.g. 45"), min: 0 })
        });
    }
    html += ui.field({
        id: "rc-requests-reviews", label: _t("Do you actively request client reviews?"), required: true,
        inner: ui.radioGroup({ id: "rc-requests-reviews", value: d.requestsReviews, options: data.options(["Yes", "No"]) })
    });
    html += ui.field({
        id: "rc-campaigns-per-month", label: _t("Marketing campaigns per month"), required: true,
        inner: ui.radioGroup({ id: "rc-campaigns-per-month", value: d.campaignsPerMonth, options: data.options(["None", "1", "2", "3-4", "5+"]) })
    });
    html += ui.field({
        id: "rc-uses-email-sms", label: _t("Do you use email or SMS campaigns?"), required: true,
        inner: ui.radioGroup({ id: "rc-uses-email-sms", value: d.usesEmailSMS, options: data.options(["Yes", "No"]) })
    });
    html += ui.field({
        id: "rc-promotes", label: _t("What do you currently promote?"),
        inner: '<div class="rc-calc__checkbox-list">' + PROMOTE_OPTS.map(function (opt) {
            return ui.checkboxRow({ id: "rc-promotes-" + opt.replace(/\s+/g, "-").toLowerCase(), checked: promotes.indexOf(opt) !== -1, label: ui.esc(_t(opt)) });
        }).join("") + "</div>"
    });
    html += ui.primaryButton({ id: "rc-continue-btn", label: _t("Continue") });
    return ui.card(html);
}

function bind(container, state, actions) {
    var d = state.d;
    container.querySelectorAll('[data-radio-group="rc-google-rating"] [data-radio-value]').forEach(function (btn) {
        btn.addEventListener("click", function () {
            var rating = btn.getAttribute("data-radio-value");
            actions.setField("googleRating", rating);
            // The review-count field is hidden for "No rating"; drop its stale value too.
            if (rating === "0") actions.setField("googleReviews", "");
            actions.rerender();
        });
    });
    var revEl = container.querySelector("#rc-google-reviews");
    if (revEl) revEl.addEventListener("input", function (e) { actions.setField("googleReviews", e.target.value); });
    container.querySelectorAll('[data-radio-group="rc-requests-reviews"] [data-radio-value]').forEach(function (btn) {
        btn.addEventListener("click", function () { actions.setField("requestsReviews", btn.getAttribute("data-radio-value")); actions.rerender(); });
    });
    container.querySelectorAll('[data-radio-group="rc-campaigns-per-month"] [data-radio-value]').forEach(function (btn) {
        btn.addEventListener("click", function () { actions.setField("campaignsPerMonth", btn.getAttribute("data-radio-value")); actions.rerender(); });
    });
    container.querySelectorAll('[data-radio-group="rc-uses-email-sms"] [data-radio-value]').forEach(function (btn) {
        btn.addEventListener("click", function () { actions.setField("usesEmailSMS", btn.getAttribute("data-radio-value")); actions.rerender(); });
    });
    PROMOTE_OPTS.forEach(function (opt) {
        var id = "rc-promotes-" + opt.replace(/\s+/g, "-").toLowerCase();
        var el = container.querySelector("#" + id);
        if (el) el.addEventListener("change", function () { actions.toggleArr("promotes", opt); });
    });
    container.querySelector("#rc-continue-btn").addEventListener("click", function () {
        if (!d.googleRating || !d.requestsReviews || !d.campaignsPerMonth || !d.usesEmailSMS) {
            actions.showError(
                !d.googleRating ? "rc-google-rating" : !d.requestsReviews ? "rc-requests-reviews" : !d.campaignsPerMonth ? "rc-campaigns-per-month" : "rc-uses-email-sms",
                _t("Please complete all required fields.")
            );
            return;
        }
        if (d.googleRating !== "0") {
            var reviewsErr = validate.numberError(d.googleReviews, { min: 0, max: 10000000, integer: true });
            if (reviewsErr) {
                actions.showError("rc-google-reviews", reviewsErr);
                return;
            }
        }
        state.adv = 2;
        actions.rerender();
    });
}

module.exports = { render: render, bind: bind };
